import type { ShipmentCarrier } from "~/shared/schemas/shipment-management-schema.ts";

export const yesNoOptions = [
	{ label: "Yes", value: "yes" },
	{ label: "No", value: "no" },
];

export const CLAIM_DETAILS_MAX_LENGTH = 200;

// "" means the user hasn't answered the yes/no question yet.
export const initFormState = {
	needHelpWithSalvage: "no",
	salvageAmount: 0,
	estimatedClaimAmount: 0,
	actualClaimAmount: 0,
	tempRecorder: "",
	fedInspection: "",
	claimReason: 0,
	// LTL claims are always classified as over freight.
	claimExceedPayAmount: "yes",
	contactName: "",
	contactEmail: "",
	contactPhone: "",
	contactExtension: "",
	claimDetails: "",
};

export type ClaimsFormData = typeof initFormState & {
	poNumber: string;
	customerName: string;
	carrier: ShipmentCarrier | undefined;
	loadDate: string | null | undefined;
	deliveryDate: string | null | undefined;
};
